import { lazy } from "react";
export const lazyIcons = {
    IconAccessibility: lazy(() => import('./IconAccessibility.mjs')),
    IconActiveIngredients: lazy(() => import('./IconActiveIngredients.mjs')),
    IconAddToWishlist: lazy(() => import('./IconAddToWishlist.mjs')),
    IconApple: lazy(() => import('./IconApple.mjs')),
    IconArrowLeft: lazy(() => import('./IconArrowLeft.mjs')),
    IconArrowRight: lazy(() => import('./IconArrowRight.mjs')),
    IconAssortment: lazy(() => import('./IconAssortment.mjs')),
    IconBaby: lazy(() => import('./IconBaby.mjs')),
    IconBacteria: lazy(() => import('./IconBacteria.mjs')),
    IconBarcode: lazy(() => import('./IconBarcode.mjs')),
    IconBeaker: lazy(() => import('./IconBeaker.mjs')),
    IconBio: lazy(() => import('./IconBio.mjs')),
    IconBladder: lazy(() => import('./IconBladder.mjs')),
    IconBlister: lazy(() => import('./IconBlister.mjs')),
    IconBloodPressureHigh: lazy(() => import('./IconBloodPressureHigh.mjs')),
    IconBookmarkHeart: lazy(() => import('./IconBookmarkHeart.mjs')),
    IconBookmarkHeartActive: lazy(() => import('./IconBookmarkHeartActive.mjs')),
    IconBug: lazy(() => import('./IconBug.mjs')),
    IconCalendar: lazy(() => import('./IconCalendar.mjs')),
    IconCamera: lazy(() => import('./IconCamera.mjs')),
    IconCancelOrder: lazy(() => import('./IconCancelOrder.mjs')),
    IconCaretDown: lazy(() => import('./IconCaretDown.mjs')),
    IconCaretLeft: lazy(() => import('./IconCaretLeft.mjs')),
    IconCaretRight: lazy(() => import('./IconCaretRight.mjs')),
    IconCaretUp: lazy(() => import('./IconCaretUp.mjs')),
    IconCbd: lazy(() => import('./IconCbd.mjs')),
    IconCertificate: lazy(() => import('./IconCertificate.mjs')),
    IconChat: lazy(() => import('./IconChat.mjs')),
    IconChatbot: lazy(() => import('./IconChatbot.mjs')),
    IconCheck: lazy(() => import('./IconCheck.mjs')),
    IconCheckCircle: lazy(() => import('./IconCheckCircle.mjs')),
    IconClose: lazy(() => import('./IconClose.mjs')),
    IconCloseCircle: lazy(() => import('./IconCloseCircle.mjs')),
    IconCloseFilledCircle: lazy(() => import('./IconCloseFilledCircle.mjs')),
    IconContactLenses: lazy(() => import('./IconContactLenses.mjs')),
    IconCooling: lazy(() => import('./IconCooling.mjs')),
    IconCopy: lazy(() => import('./IconCopy.mjs')),
    IconCosmetics: lazy(() => import('./IconCosmetics.mjs')),
    IconCup: lazy(() => import('./IconCup.mjs')),
    IconDelivery: lazy(() => import('./IconDelivery.mjs')),
    IconDescription: lazy(() => import('./IconDescription.mjs')),
    IconDiabetes: lazy(() => import('./IconDiabetes.mjs')),
    IconDiscount: lazy(() => import('./IconDiscount.mjs')),
    IconDoctor: lazy(() => import('./IconDoctor.mjs')),
    IconDocument: lazy(() => import('./IconDocument.mjs')),
    IconDonation: lazy(() => import('./IconDonation.mjs')),
    IconDownload: lazy(() => import('./IconDownload.mjs')),
    IconEuro: lazy(() => import('./IconEuro.mjs')),
    IconEyeClose: lazy(() => import('./IconEyeClose.mjs')),
    IconEyeOpen: lazy(() => import('./IconEyeOpen.mjs')),
    IconFilter: lazy(() => import('./IconFilter.mjs')),
    IconFingerprint: lazy(() => import('./IconFingerprint.mjs')),
    IconFlag: lazy(() => import('./IconFlag.mjs')),
    IconFlashLightCameraOff: lazy(() => import('./IconFlashLightCameraOff.mjs')),
    IconFlashLightCameraOn: lazy(() => import('./IconFlashLightCameraOn.mjs')),
    IconHaemorrhoids: lazy(() => import('./IconHaemorrhoids.mjs')),
    IconHayFever: lazy(() => import('./IconHayFever.mjs')),
    IconHeadache: lazy(() => import('./IconHeadache.mjs')),
    IconHealth: lazy(() => import('./IconHealth.mjs')),
    IconHelp: lazy(() => import('./IconHelp.mjs')),
    IconHome: lazy(() => import('./IconHome.mjs')),
    IconHomeopathic: lazy(() => import('./IconHomeopathic.mjs')),
    IconHourglass: lazy(() => import('./IconHourglass.mjs')),
    IconImage: lazy(() => import('./IconImage.mjs')),
    IconInfo: lazy(() => import('./IconInfo.mjs')),
    IconItem: lazy(() => import('./IconItem.mjs')),
    IconLeaf: lazy(() => import('./IconLeaf.mjs')),
    IconLeaflet: lazy(() => import('./IconLeaflet.mjs')),
    IconLocation: lazy(() => import('./IconLocation.mjs')),
    IconLockClosed: lazy(() => import('./IconLockClosed.mjs')),
    IconLockOpen: lazy(() => import('./IconLockOpen.mjs')),
    IconLocker: lazy(() => import('./IconLocker.mjs')),
    IconLogin: lazy(() => import('./IconLogin.mjs')),
    IconLogout: lazy(() => import('./IconLogout.mjs')),
    IconMail: lazy(() => import('./IconMail.mjs')),
    IconMailActive: lazy(() => import('./IconMailActive.mjs')),
    IconManufacturer: lazy(() => import('./IconManufacturer.mjs')),
    IconMap: lazy(() => import('./IconMap.mjs')),
    IconMask: lazy(() => import('./IconMask.mjs')),
    IconMedicalAdviceCommunication: lazy(() => import('./IconMedicalAdviceCommunication.mjs')),
    IconMedicalChatbot: lazy(() => import('./IconMedicalChatbot.mjs')),
    IconMenu: lazy(() => import('./IconMenu.mjs')),
    IconMinus: lazy(() => import('./IconMinus.mjs')),
    IconMinusCircle: lazy(() => import('./IconMinusCircle.mjs')),
    IconMore: lazy(() => import('./IconMore.mjs')),
    IconMultiplierOverview: lazy(() => import('./IconMultiplierOverview.mjs')),
    IconNfc: lazy(() => import('./IconNfc.mjs')),
    IconNoSmoking: lazy(() => import('./IconNoSmoking.mjs')),
    IconNonPrescitption: lazy(() => import('./IconNonPrescitption.mjs')),
    IconNotifications: lazy(() => import('./IconNotifications.mjs')),
    IconNotificationsActive: lazy(() => import('./IconNotificationsActive.mjs')),
    IconNowAvailable: lazy(() => import('./IconNowAvailable.mjs')),
    IconNowUnavailable: lazy(() => import('./IconNowUnavailable.mjs')),
    IconOpenInLaunchExternal: lazy(() => import('./IconOpenInLaunchExternal.mjs')),
    IconOrderProcessing: lazy(() => import('./IconOrderProcessing.mjs')),
    IconPackage: lazy(() => import('./IconPackage.mjs')),
    IconPackageDamaged: lazy(() => import('./IconPackageDamaged.mjs')),
    IconPackageReceived: lazy(() => import('./IconPackageReceived.mjs')),
    IconPackageReturn: lazy(() => import('./IconPackageReturn.mjs')),
    IconPasteAndroid: lazy(() => import('./IconPasteAndroid.mjs')),
    IconPasteIOs: lazy(() => import('./IconPasteIOs.mjs')),
    IconPaymentMethod: lazy(() => import('./IconPaymentMethod.mjs')),
    IconPdf: lazy(() => import('./IconPdf.mjs')),
    IconPen: lazy(() => import('./IconPen.mjs')),
    IconPet: lazy(() => import('./IconPet.mjs')),
    IconPharmacy: lazy(() => import('./IconPharmacy.mjs')),
    IconPhone: lazy(() => import('./IconPhone.mjs')),
    IconPickUp: lazy(() => import('./IconPickUp.mjs')),
    IconPills: lazy(() => import('./IconPills.mjs')),
    IconPlaceholder: lazy(() => import('./IconPlaceholder.mjs')),
    IconPlantBased: lazy(() => import('./IconPlantBased.mjs')),
    IconPlayIconOnly: lazy(() => import('./IconPlayIconOnly.mjs')),
    IconPlayInACircle: lazy(() => import('./IconPlayInACircle.mjs')),
    IconPlus: lazy(() => import('./IconPlus.mjs')),
    IconPlusCircle: lazy(() => import('./IconPlusCircle.mjs')),
    IconPrescription: lazy(() => import('./IconPrescription.mjs')),
    IconPrescriptionMail: lazy(() => import('./IconPrescriptionMail.mjs')),
    IconPresentGiftCoupon: lazy(() => import('./IconPresentGiftCoupon.mjs')),
    IconPresentGiftCouponSide: lazy(() => import('./IconPresentGiftCouponSide.mjs')),
    IconPrinter: lazy(() => import('./IconPrinter.mjs')),
    IconProfileUserAvatar: lazy(() => import('./IconProfileUserAvatar.mjs')),
    IconProfileUserAvatarLoggedIn: lazy(() => import('./IconProfileUserAvatarLoggedIn.mjs')),
    IconPromotionOverview: lazy(() => import('./IconPromotionOverview.mjs')),
    IconProteinPowder: lazy(() => import('./IconProteinPowder.mjs')),
    IconReceipt: lazy(() => import('./IconReceipt.mjs')),
    IconReload: lazy(() => import('./IconReload.mjs')),
    IconReorder: lazy(() => import('./IconReorder.mjs')),
    IconSadFace: lazy(() => import('./IconSadFace.mjs')),
    IconSanitizer: lazy(() => import('./IconSanitizer.mjs')),
    IconSavings: lazy(() => import('./IconSavings.mjs')),
    IconScales: lazy(() => import('./IconScales.mjs')),
    IconScannerBarcode: lazy(() => import('./IconScannerBarcode.mjs')),
    IconScannerERx: lazy(() => import('./IconScannerERx.mjs')),
    IconSeal: lazy(() => import('./IconSeal.mjs')),
    IconSearch: lazy(() => import('./IconSearch.mjs')),
    IconSettings: lazy(() => import('./IconSettings.mjs')),
    IconShareIOs: lazy(() => import('./IconShareIOs.mjs')),
    IconShareWebAndroid: lazy(() => import('./IconShareWebAndroid.mjs')),
    IconShelterStayAtHome: lazy(() => import('./IconShelterStayAtHome.mjs')),
    IconShield: lazy(() => import('./IconShield.mjs')),
    IconShoppingCart: lazy(() => import('./IconShoppingCart.mjs')),
    IconShoppingCartFilled: lazy(() => import('./IconShoppingCartFilled.mjs')),
    IconShoppingCartWithCheckmark: lazy(() => import('./IconShoppingCartWithCheckmark.mjs')),
    IconSmiley: lazy(() => import('./IconSmiley.mjs')),
    IconSort: lazy(() => import('./IconSort.mjs')),
    IconSport: lazy(() => import('./IconSport.mjs')),
    IconSpray: lazy(() => import('./IconSpray.mjs')),
    IconStar: lazy(() => import('./IconStar.mjs')),
    IconStarFilled: lazy(() => import('./IconStarFilled.mjs')),
    IconStarHalf: lazy(() => import('./IconStarHalf.mjs')),
    IconSuperFastDelivery: lazy(() => import('./IconSuperFastDelivery.mjs')),
    IconSupport: lazy(() => import('./IconSupport.mjs')),
    IconSustainability: lazy(() => import('./IconSustainability.mjs')),
    IconSwapExchange: lazy(() => import('./IconSwapExchange.mjs')),
    IconSwissFranc: lazy(() => import('./IconSwissFranc.mjs')),
    IconTag: lazy(() => import('./IconTag.mjs')),
    IconThumbDown: lazy(() => import('./IconThumbDown.mjs')),
    IconThumbUp: lazy(() => import('./IconThumbUp.mjs')),
    IconTime: lazy(() => import('./IconTime.mjs')),
    IconTouch: lazy(() => import('./IconTouch.mjs')),
    IconTrashDelete: lazy(() => import('./IconTrashDelete.mjs')),
    IconUpload: lazy(() => import('./IconUpload.mjs')),
    IconVegan: lazy(() => import('./IconVegan.mjs')),
    IconVegetarian: lazy(() => import('./IconVegetarian.mjs')),
    IconVoucher: lazy(() => import('./IconVoucher.mjs')),
    IconWarning: lazy(() => import('./IconWarning.mjs')),
};
